const OVERLAY_BEHAVIOUR_ON_HOVER = {
  APPEARS: 'APPEARS',
  DISAPPEARS: 'DISAPPEARS',
  ALWAYS_SHOW: 'ALWAYS_SHOW',
  NEVER_SHOW: 'NEVER_SHOW',
};
export default OVERLAY_BEHAVIOUR_ON_HOVER;
